if (!customElements.get('product-form')) {
  customElements.define('product-form', class AddToCart extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form[action$="/cart/add"]');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.formSubmit.bind(this)); // submit event
      this.errorAlert = this.querySelector('.product-form__error-message-wrapper');
    }

    formSubmit(evt) {
      evt.preventDefault();
      this.querySelector('button[name="add"]').classList.add('loading');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      config.body = formData;

      const messageField = evt.target.querySelector('#gift_card_message');
      const gift_card_message = messageField ? messageField.value.trim() : '';

      if (gift_card_message !== '') {
        // Спочатку зберігаємо gift_card.message в cart attributes і notes
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              'gift_card.message': gift_card_message
            },
            note: gift_card_message // додаємо в notes
          })
        })
            .then(() => {
              // Після оновлення кошика додаємо товар
              return fetch(`${routes.cart_add_url}`, config);
            })
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.errorMessage(response);
                return;
              }
              this.showAddToCartPopup(response);
              this.succses();
            })
            .catch((error) => {
              console.log(error);
            });

      } else {
        // Якщо повідомлення порожнє або поля немає — додаємо товар без змін
        fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.errorMessage(response);
                return;
              }
              this.showAddToCartPopup(response);
              // console.log(response);

              this.succses();
            })
            .catch((error) => {
              console.log(error);
            });
      }
    }

    showAddToCartPopup(item) {
      const existingPopup = document.querySelector('.add-to-cart-popup');
      const succsesMessage = document.querySelector('#cart-popup')?.dataset.succsesMessagePopup;
      const delayPopup = document.querySelector('#cart-popup')?.dataset.delayPopup;
      const escapeHtml = (value = '') => String(value).replace(/[&<>"']/g, (character) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      })[character]);
      if (existingPopup) {
        existingPopup.classList.remove('fade-in');
        existingPopup.classList.add('fade-out');
        setTimeout(() => existingPopup.remove(), 300);
      }

      // const color = item?.properties?.['варіанти шпильки']?.trim();
      let variantDisplayTitles = {};
      const variantDisplayTitlesNode = this.querySelector('[data-variant-display-titles]');
      if (variantDisplayTitlesNode) {
        try {
          variantDisplayTitles = JSON.parse(variantDisplayTitlesNode.textContent);
        } catch (error) {
          console.error('Unable to parse variant display titles.', error);
        }
      }

      const productDisplayTitle = this.dataset.displayProductTitle || item.product_title;
      const variantDisplayTitle = variantDisplayTitles[String(item.variant_id)] || item.variant_title;
      const safeProductDisplayTitle = escapeHtml(productDisplayTitle);
      const safeVariantDisplayTitle = escapeHtml(variantDisplayTitle);
      const safeSuccessMessage = escapeHtml(succsesMessage);
      const safeImageUrl = escapeHtml(item.image);

      let imageUrl = safeImageUrl;
      imageUrl += imageUrl.includes('?') ? '&width=200' : '?width=200';

      let detailsHTML = `<div class="popup-title">${safeProductDisplayTitle}</div>`;
      if (variantDisplayTitle && variantDisplayTitle !== 'Default Title') {
        detailsHTML += `<div class="popup-option">${safeVariantDisplayTitle}</div>`;
      }
      detailsHTML += `<div class="popup-success">${safeSuccessMessage}</div>`;

      const popup = document.createElement('div');
      popup.className = 'added-product-to-cart-popup';

      popup.innerHTML = `
        <button class="popup-close" aria-label="Close">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.7938 17.7124L12.0876 12.0062L17.7938 6.3" stroke="#212121" stroke-linejoin="round"/>
            <path d="M6.2062 6.3L11.9124 12.0062L6.2062 17.7124" stroke="#212121" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="popup-content">
          <img src="${imageUrl}" alt="${safeProductDisplayTitle}" />
          <div class="popup-details">
            ${detailsHTML}
          </div>
        </div>
      `;

      setTimeout(() => {
        popup.classList.add('fade-in');
      }, 10);

      document.body.appendChild(popup);

      popup.querySelector('.popup-close').addEventListener('click', () => {
        popup.classList.remove('fade-in');
        popup.classList.add('fade-out');
        setTimeout(() => popup.remove(), 300);
      });

      popup.querySelector(".popup-content")?.addEventListener("click", event => {
        popup.classList.remove('fade-in');
        popup.classList.add('fade-out');
        setTimeout(() => {
          popup.remove();
          openCartPopup();
        }, 300);
      })


      const escListener = (e) => {
        if (e.key === 'Escape') {
          popup.classList.remove('fade-in');
          popup.classList.add('fade-out');
          setTimeout(() => popup.remove(), 300);
          document.removeEventListener('keydown', escListener);
        }
      };
      document.addEventListener('keydown', escListener);

      setTimeout(() => {
        if (document.body.contains(popup)) {
          popup.classList.remove('fade-in');
          popup.classList.add('fade-out');
          setTimeout(() => popup.remove(), 300);
        }
      }, delayPopup*1000);
    }

    errorMessage(resp) {
      console.log(resp.description);
      if (resp.description.email?.[0] == "Email can't be blank") {
        document.querySelector(".product-form__error-message--send")?.classList.add("d-none");
        document.querySelector(".product-form__error-message--email_invalid")?.classList.add("d-none");

        document.querySelector(".product-form__error-message--email_blank")?.classList.remove("d-none");
      } else if( resp.description.email?.[0] == "Email is invalid") {
        document.querySelector(".product-form__error-message--send")?.classList.add("d-none");
        document.querySelector(".product-form__error-message--email_blank")?.classList.add("d-none");

        document.querySelector(".product-form__error-message--email_invalid")?.classList.remove("d-none");
      } else if( resp.description.send_on?.[0] == "Send on must be within 90 days from now") {
        document.querySelector(".product-form__error-message--email_blank")?.classList.add("d-none");
        document.querySelector(".product-form__error-message--email_invalid")?.classList.add("d-none");

        document.querySelector(".product-form__error-message--send")?.classList.remove("d-none");
      }

      this.errorAlert.classList.remove('d-none');
      this.querySelector('button[name="add"]').classList.remove('loading');
    }

    succses() {
      console.log("Success");
      this.errorAlert.classList.add('d-none');
      this.querySelector('button[name="add"]').classList.remove('loading');
      updateCartBuble();
      // openCartPopup();
      renderCart();
      renderCartPage();
    }
  });
}

function renderCartPage() {
  const cartPage = document.querySelector(".cart.cart-page");
  if (!cartPage) return;

  fetch(`${window.shopUrl}/cart`)
    .then((response) => response.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const updatedCartPage = doc.querySelector(".cart.cart-page");
      if (!updatedCartPage) return;

      cartPage.innerHTML = updatedCartPage.innerHTML;
      if (typeof initCartQuantityControls === 'function') {
        initCartQuantityControls();
      }
      if (typeof initCartRemoveButtons === 'function') {
        initCartRemoveButtons();
      }

      if (window.enabledCurrencySelector && typeof updatePrices === 'function') {
        updatePrices();
      }
      if (typeof applyCartUpsellDismissal === 'function') {
        applyCartUpsellDismissal(cartPage);
      }
      initCartCompleteLookRails(cartPage);
    })
    .catch((error) => console.error("Unable to render cart page:", error));
}

function getCartCompleteLookRail(block) {
  return block?.querySelector('.cart-complete-look__list');
}

function updateCartCompleteLookControls(block) {
  const rail = getCartCompleteLookRail(block);
  if (!rail) return;

  const prev = block.querySelector('[data-cart-complete-look-prev]');
  const next = block.querySelector('[data-cart-complete-look-next]');
  const maxScrollLeft = rail.scrollWidth - rail.clientWidth;
  const hasOverflow = maxScrollLeft > 1;

  block.classList.toggle('has-overflow', hasOverflow);

  if (prev) prev.disabled = !hasOverflow || rail.scrollLeft <= 1;
  if (next) next.disabled = !hasOverflow || rail.scrollLeft >= maxScrollLeft - 1;
}

function scrollCartCompleteLookRail(button) {
  const block = button.closest('.cart-complete-look');
  const rail = getCartCompleteLookRail(block);
  const firstItem = rail?.querySelector('.cart-complete-look__item');
  if (!block || !rail || !firstItem) return;

  const gap = parseFloat(window.getComputedStyle(rail).columnGap || window.getComputedStyle(rail).gap) || 0;
  const distance = firstItem.getBoundingClientRect().width + gap;
  const direction = button.matches('[data-cart-complete-look-prev]') ? -1 : 1;

  rail.scrollBy({
    left: distance * direction,
    behavior: 'smooth'
  });

  window.setTimeout(function () {
    updateCartCompleteLookControls(block);
  }, 350);
}

function getCartCompleteLookDismissed() {
  try {
    return window.sessionStorage?.getItem('tsvite.cartCompleteLook.dismissed') === 'true';
  } catch (error) {
    return false;
  }
}

function setCartCompleteLookDismissed() {
  try {
    window.sessionStorage?.setItem('tsvite.cartCompleteLook.dismissed', 'true');
  } catch (error) {
    // Ignore storage errors; the current DOM can still be dismissed.
  }
}

function applyCartCompleteLookDismissal(root = document) {
  const isDismissed = getCartCompleteLookDismissed();
  root.querySelectorAll('[data-cart-complete-look-dismissible]').forEach((block) => {
    block.classList.toggle('d-none', isDismissed);
  });
}

window.applyCartCompleteLookDismissal = applyCartCompleteLookDismissal;

function bindCartCompleteLookDismissal() {
  if (document.documentElement.dataset.cartCompleteLookDismissBound) return;

  document.documentElement.dataset.cartCompleteLookDismissBound = 'true';
  document.addEventListener('click', function (event) {
    const dismissButton = event.target.closest('[data-cart-complete-look-dismiss]');
    if (!dismissButton) return;

    const block = dismissButton.closest('[data-cart-complete-look-dismissible]');
    setCartCompleteLookDismissed();
    block?.classList.add('d-none');
  });
}

function bindCartCompleteLookRailClicks() {
  if (document.documentElement.dataset.cartCompleteLookRailClicksBound) return;

  document.documentElement.dataset.cartCompleteLookRailClicksBound = 'true';
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-cart-complete-look-prev], [data-cart-complete-look-next]');
    if (!button || button.disabled) return;

    scrollCartCompleteLookRail(button);
  });

  window.addEventListener('resize', function () {
    initCartCompleteLookRails();
  });
}

function initCartCompleteLookRails(root = document) {
  bindCartCompleteLookDismissal();
  bindCartCompleteLookRailClicks();
  applyCartCompleteLookDismissal(root);

  root.querySelectorAll('.cart-complete-look').forEach((block) => {
    const rail = getCartCompleteLookRail(block);
    if (!rail) return;

    if (!rail.dataset.cartCompleteLookRailBound) {
      rail.dataset.cartCompleteLookRailBound = 'true';
      rail.addEventListener('scroll', function () {
        updateCartCompleteLookControls(block);
      }, { passive: true });
    }

    updateCartCompleteLookControls(block);
    requestAnimationFrame(function () {
      updateCartCompleteLookControls(block);
    });
  });
}

window.initCartCompleteLookRails = initCartCompleteLookRails;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initCartCompleteLookRails();
  });
} else {
  initCartCompleteLookRails();
}

if (!customElements.get('cart-upsell-variants')) {
  customElements.define('cart-upsell-variants', class CartUpsellVariants extends HTMLElement {
    constructor() {
      super();

      this.form = document.getElementById(this.dataset.productFormId);
      this.product = this.closest('.cart-upsell__product');
      this.variantInput = this.form?.querySelector('[name="id"]');
      this.addButton = this.form?.querySelector('[name="add"]');
      this.price = this.product?.querySelector('[data-cart-upsell-price]');
      this.comparePrice = this.product?.querySelector('[data-cart-upsell-compare-price]');
      this.image = this.product?.querySelector('[data-cart-upsell-image]');
      this.variantDataNode = this.querySelector('[data-cart-upsell-variants-json]');
      this.variantData = this.variantDataNode ? JSON.parse(this.variantDataNode.textContent) : [];
      this.allowedVariantIds = (this.dataset.allowedVariantIds || '')
        .split(',')
        .map((variantId) => variantId.trim())
        .filter(Boolean);

      if (this.allowedVariantIds.length) {
        this.variantData = this.variantData.filter((variant) => {
          return this.allowedVariantIds.includes(String(variant.id));
        });
      }

      this.variantImageCache = new Map();
      this.addEventListener('change', this.onVariantChange.bind(this));
      this.addEventListener('pointerdown', this.onVariantPointer.bind(this));
      this.addEventListener('pointerover', this.onVariantPointer.bind(this));
      this.initDropdowns();
      this.preloadVariantImages();
      this.syncVariant();
    }

    onVariantChange() {
      this.syncVariant();
    }

    onVariantPointer(event) {
      const input = this.getVariantInputFromEvent(event);
      if (!input || input.disabled) return;

      const variant = this.getVariantForInput(input);
      this.preloadVariantImage(variant);

      if (event.type === 'pointerdown') {
        this.updateImageForVariant(variant);
      }
    }

    syncVariant() {
      this.options = this.getSelectedOptions();
      this.currentVariant = this.variantData.find((variant) => {
        return variant.options.every((option, index) => option === this.options[index]);
      });

      this.updateVariantInput();
      this.updateImage();
      this.updatePrices();
      this.updateAddButton();
      this.updateOptionAvailability();
      this.updateSelectedLabels();
      this.closeDropdowns();
    }

    getSelectedOptions() {
      return Array.from(this.querySelectorAll('fieldset')).map((fieldset) => {
        return fieldset.querySelector('input[type="radio"]:checked')?.value;
      });
    }

    getVariantInputFromEvent(event) {
      const target = event.target.closest('input[type="radio"], .cart-upsell__value');
      if (!target) return null;

      if (target.matches('input[type="radio"]')) {
        return target;
      }

      return target.querySelector('input[type="radio"]');
    }

    getVariantForInput(input) {
      const fieldset = input.closest('fieldset');
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      const optionIndex = fieldsets.indexOf(fieldset);

      if (optionIndex < 0) return null;

      const candidateOptions = this.getSelectedOptions();
      candidateOptions[optionIndex] = input.value;

      return this.variantData.find((variant) => {
        return variant.options.every((option, index) => option === candidateOptions[index]);
      });
    }

    updateVariantInput() {
      if (!this.variantInput || !this.currentVariant) return;

      this.variantInput.value = this.currentVariant.id;
    }

    updatePrices() {
      if (!this.currentVariant) return;

      this.updatePriceElement(this.price, this.currentVariant.price, this.currentVariant.id);

      if (!this.comparePrice) return;

      if (this.currentVariant.compare_at_price && this.currentVariant.compare_at_price > this.currentVariant.price) {
        this.comparePrice.classList.remove('d-none');
        this.updatePriceElement(this.comparePrice, this.currentVariant.compare_at_price, this.currentVariant.id);
      } else {
        this.comparePrice.classList.add('d-none');
        this.comparePrice.textContent = '';
        this.comparePrice.dataset.basePrice = '';
      }

      if (window.enabledCurrencySelector && typeof updatePrices === 'function') {
        updatePrices();
      }
    }

    updateImage() {
      if (!this.image || !this.currentVariant) return;

      this.updateImageForVariant(this.currentVariant);
    }

    updateImageForVariant(variant) {
      if (!this.image || !variant) return;

      const imageData = this.getVariantImageData(variant);

      if (!imageData) {
        this.restoreFallbackImage();
        return;
      }

      this.image.src = imageData.src;
      this.image.srcset = imageData.srcset;
      if (imageData.alt) {
        this.image.alt = imageData.alt;
      }
    }

    preloadVariantImages() {
      this.variantData.forEach((variant) => this.preloadVariantImage(variant));
    }

    preloadVariantImage(variant) {
      const imageData = this.getVariantImageData(variant);

      if (!imageData || this.variantImageCache.has(imageData.src)) return;

      const image = new Image();
      image.decoding = 'async';
      image.src = imageData.src;
      image.srcset = imageData.srcset;
      this.variantImageCache.set(imageData.src, image);
    }

    getVariantImageData(variant) {
      if (!variant) return null;

      const imageSrc = variant.featured_image?.src || variant.featured_media?.preview_image?.src;
      if (!imageSrc) return null;

      const sizedSrc = this.getSizedImageUrl(imageSrc, '360x');

      return {
        src: sizedSrc,
        srcset: [
          `${this.getSizedImageUrl(imageSrc, '120x')} 120w`,
          `${this.getSizedImageUrl(imageSrc, '180x')} 180w`,
          `${this.getSizedImageUrl(imageSrc, '240x')} 240w`,
          `${sizedSrc} 360w`
        ].join(', '),
        alt: variant.featured_image?.alt || variant.featured_media?.alt || this.image?.alt || ''
      };
    }

    restoreFallbackImage() {
      if (!this.image) return;

      if (this.image.dataset.fallbackSrc) {
        this.image.src = this.image.dataset.fallbackSrc;
      }
      if (this.image.dataset.fallbackSrcset) {
        this.image.srcset = this.image.dataset.fallbackSrcset;
      }
    }

    getSizedImageUrl(src, size) {
      if (!src) return src;

      if (window.Shopify?.Image?.getSizedImageUrl) {
        return window.Shopify.Image.getSizedImageUrl(src, size);
      }

      const [path, query] = src.split('?');
      const sizedPath = path.replace(/(_(?:pico|icon|thumb|small|compact|medium|large|grande|original|\d+x\d*|x\d+))?(\.(?:jpe?g|png|webp|gif))$/i, `_${size}$2`);
      return query ? `${sizedPath}?${query}` : sizedPath;
    }

    updatePriceElement(element, price, variantId) {
      if (!element) return;

      element.dataset.basePrice = this.formatBasePrice(price);
      element.setAttribute('bss-b2b-variant-id', variantId);
      element.textContent = this.formatVisiblePrice(price, element.dataset.currencyLabel);
    }

    formatBasePrice(price) {
      const amount = price / 100;
      return Number.isInteger(amount) ? String(amount) : amount.toFixed(2);
    }

    formatVisiblePrice(price, currencyLabel = '') {
      const normalizedCurrency = currencyLabel.trim();

      if (window.Shopify?.formatMoney) {
        return `${window.Shopify.formatMoney(price).replace('.00', '').replace(/,/g, '')} ${normalizedCurrency}`.trim();
      }

      return `${this.formatBasePrice(price)} ${normalizedCurrency}`.trim();
    }

    updateAddButton() {
      if (!this.addButton) return;

      if (this.currentVariant?.available) {
        this.addButton.removeAttribute('disabled');
      } else {
        this.addButton.setAttribute('disabled', 'disabled');
      }
    }

    updateOptionAvailability() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));

      fieldsets.forEach((fieldset, optionIndex) => {
        fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
          const candidateOptions = [...this.options];
          candidateOptions[optionIndex] = input.value;
          const hasAvailableVariant = this.variantData.some((variant) => {
            return variant.available && variant.options.every((option, index) => option === candidateOptions[index]);
          });

          input.disabled = !hasAvailableVariant;
          input.closest('.cart-upsell__value')?.classList.toggle('is-disabled', !hasAvailableVariant);
        });
      });
    }

    initDropdowns() {
      this.querySelectorAll('.cart-upsell__selected').forEach((button) => {
        button.addEventListener('click', () => {
          const fieldset = button.closest('fieldset');
          const isOpen = fieldset?.classList.contains('is-open');

          this.closeDropdowns(fieldset);
          fieldset?.classList.toggle('is-open', !isOpen);
          button.setAttribute('aria-expanded', String(!isOpen));
        });
      });
    }

    updateSelectedLabels() {
      this.querySelectorAll('fieldset').forEach((fieldset) => {
        const selectedInput = fieldset.querySelector('input[type="radio"]:checked');
        const selectedLabel = fieldset.querySelector('[data-cart-upsell-selected]');

        if (selectedInput && selectedLabel) {
          selectedLabel.textContent = selectedInput.value;
        }

        fieldset.querySelectorAll('.cart-upsell__value').forEach((label) => {
          label.classList.toggle('is-selected', label.querySelector('input[type="radio"]')?.checked);
        });
      });
    }

    closeDropdowns(exceptFieldset = null) {
      this.querySelectorAll('fieldset.is-open').forEach((fieldset) => {
        if (fieldset === exceptFieldset) return;

        fieldset.classList.remove('is-open');
        fieldset.querySelector('.cart-upsell__selected')?.setAttribute('aria-expanded', 'false');
      });
    }
  });
}
